import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useFeatureFlagsAccess } from "@context/FeatureFlagsAccessContext/FeatureFlagsAccessContext";
import ApiFactory from "neon-frontend-utils/src/api/factory";
import translator from "neon-frontend-utils/src/translator";
import AppConfig from "./../../App.config";
import Menu from "./components/Menu/Menu";

const Index = ({ showModalToSwitchOrganisation, driverObj }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { features, checkingAccess } = useFeatureFlagsAccess();

    const languageId = useSelector((state) => state.switchLanguageReducer.languageId);

    const api = ApiFactory.get("neon");
    const user = api.getAuthenticator().getUser();

    const [selectedMenuNode, setSelectedMenuNode] = useState(location.pathname);
    const [menuReady, setMenuReady] = useState(false);

    const navigateToRoute = (link) => {
        if (location.pathname === link) {
            return;
        }

        navigate(link);
    };

    useEffect(() => {
        setSelectedMenuNode(location.pathname);
    }, [location.pathname]);

    useEffect(() => {
        // If still checking access, don't do anything yet
        if (checkingAccess) {
            return;
        }

        // Once access check is complete, set menu as ready.
        // This prevents certain menu items (like "teams") from
        // popping up with a delay after the initial render
        setMenuReady(true);
    }, [checkingAccess, features]);

    const menuItems = menuReady
        ? AppConfig.menuItems.filter((item) => {
              if (item.featureFlag) {
                  return features[item.featureFlag] && !checkingAccess;
              }
              return true;
          })
        : [];

    const subMenuItems = AppConfig.subMenuItems;

    return (
        <Menu
            driverObj={driverObj}
            i18n={translator(languageId, "cp_menu")}
            languageId={languageId}
            menuItems={menuItems}
            navigateToRoute={navigateToRoute}
            selectedMenuNode={selectedMenuNode}
            showModalToSwitchOrganisation={showModalToSwitchOrganisation}
            subMenuItems={subMenuItems}
            user={user}
        />
    );
};

export default Index;
